// src/context/AuthContext.jsx

import { createContext, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  loginUser,
  signUpUser,
  logoutUser,
  validateToken,
  markTokenValidated,
} from "../Redux/ReduxSlices/authSlice";

export const AuthContext = createContext(undefined);

export function AuthProvider({ children }) {
  const { userData, token, isAuthenticated, loading, error, tokenValidated } =
    useSelector((state) => state.auth);

  const profile = useSelector((state) => state.profile.details);
  const dispatch = useDispatch();

  const value = {
    user: userData,
    token,
    isAuthenticated,
    isLoading: loading,
    error,
    profile,
    tokenValidated,
    login: (payload) => dispatch(loginUser(payload)),
    signup: (payload) => dispatch(signUpUser(payload)),
    logout: () => dispatch(logoutUser()),
    validateToken: () => dispatch(validateToken()),
    markTokenValidated: () => dispatch(markTokenValidated()),
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (context == null) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
